import { resolveMarket, type Market } from './marketIndicator';
import type { RuntimeAppConfig } from './runtimeConfig';

// The legacy panel's origin per market. A per-PR preview reports MARKET=dev and so borrows the
// permanent dev legacy — a preview has no legacy counterpart of its own to point at.
const LEGACY_ORIGIN: Record<Market, string> = {
  es: 'https://admin.citibox.com',
  uk: 'https://uk.admin.citibox.com',
  sandbox: 'https://admin.citibox-sandbox.com',
  dev: 'https://amz1.admin.citibox.tech',
};

const LOCK_MAINTENANCE_PATH = '/mantenimiento_cerradura.php';

// Uppercase, and the case is load-bearing: PHP's $_GET is case-sensitive, so `?id=` reaches the
// screen as no box at all — it does not 404, it silently opens lock maintenance with nothing
// selected. Verified empirically against the legacy on 2026-08-05; do not "normalize" it.
const BOX_ID_PARAM = 'ID';

// Deep link to the legacy lock-maintenance screen for one «buzón». Returns null — meaning no
// link is offered at all — when the market cannot be resolved: box ids are per-market database
// identifiers that plausibly collide across markets, so guessing would not 404, it would open a
// real but unrelated «buzón» on a screen where lock pointers can be moved. The id is
// percent-encoded because it reaches the client as an open string: a value carrying & or #
// would otherwise rewrite the very query it is meant to fill.
export function legacyBoxMaintenanceUrl(config: RuntimeAppConfig, boxId: string): string | null {
  const market = resolveMarket(config);
  if (market === null) return null;
  return `${LEGACY_ORIGIN[market]}${LOCK_MAINTENANCE_PATH}?${BOX_ID_PARAM}=${encodeURIComponent(boxId)}`;
}
